import Login from "./AuthPages/Login/Index";
import Otp from "./AuthPages/Otp/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import ResetPassword from "./AuthPages/resetPassword/Index";
import ContentPage from "./SideTabPages/ContentPages";
import AddContentPage from "./SideTabPages/ContentPages/add";
import Dashboard from "./SideTabPages/Dashboard";
import Earnings from "./SideTabPages/Earnings";
import Faq from "./SideTabPages/Faq";
import AddFaq from "./SideTabPages/Faq/add";
import Help from "./SideTabPages/Help";
import HelpDetail from "./SideTabPages/Help/detail";
import ManageEarning from "./SideTabPages/ManageEearning";
import ManageHotelAdminDetail from "./SideTabPages/ManageHotelAdmin/Detail";
import ServiceProviderRequest from "./SideTabPages/ManageServiceProvider/NewRequest";
import RegisterServiceProvider from "./SideTabPages/ManageServiceProvider/Register";
import AddNewServiceProvider from "./SideTabPages/ManageServiceProvider/Register/Add";
import ServiceProviderDetail from "./SideTabPages/ManageServiceProvider/detail";
import ManageUser from "./SideTabPages/ManageOrganiser";
import AddEditUser from "./SideTabPages/ManageOrganiser/Add";
import UserDetail from "./SideTabPages/ManageOrganiser/detail";
import Accounting from "./SideTabPages/Accounting";
import ManageSubscription from "./SideTabPages/ManageSubscription";
import SubscriptionAdd from "./SideTabPages/ManageSubscription/Add";
import ViewSubscription from "./SideTabPages/ManageSubscription/View";
import PaymentsManagement from "./SideTabPages/PaymentsManagement";
import Promocode from "./SideTabPages/Promocode";
import AddPromoCode from "./SideTabPages/Promocode/add";
import PromoCodeDetail from "./SideTabPages/Promocode/detail";
import PromotionList from "./SideTabPages/Promotion";
import AddPromotion from "./SideTabPages/Promotion/add";
import Settings from "./SideTabPages/Settings";
import EditProfile from "./SideTabPages/Settings/EditProfile";
import ManagePassword from "./SideTabPages/Settings/ManagePassword";
import BasicSettings from "./SideTabPages/Settings/Profile/BasicSettings";
import SystemAccess from "./SideTabPages/SystemAccess";
import Role from "./SideTabPages/Role";
import AddSubAdmin from "./SideTabPages/SystemAccess/add";
import AddRole from "./SideTabPages/Role/Add";
import InquiryManagement from "./EnquiryList";
import EditJobPost from "./SideTabPages/ManageOrganiser/JobPost/EditJobPost";
import ViewJobPost from "./SideTabPages/ManageOrganiser/JobPost/ViewJobPost";
import ManageHotelAdmin from "./SideTabPages/ManageHotelAdmin";
import AddEditHotelAdmin from "./SideTabPages/ManageHotelAdmin/Add";
import ManageReferal from "./SideTabPages/ManageReferal";
import OrderManagement from "./SideTabPages/ManageBooking";
import OrderDetail from "./SideTabPages/ManageBooking/Detail";
import Amenity from "./SideTabPages/Amenities";
import AddAmenity from "./SideTabPages/Amenities/Add";
import AmenitiesDetail from "./SideTabPages/Amenities/detail";
import RoomAmenity from "./SideTabPages/RoomAmenities";
import AddRoomAmenity from "./SideTabPages/RoomAmenities/Add";
import RoomAmenityDetail from "./SideTabPages/RoomAmenities/Detail";
import ManageHotel from "./SideTabPages/Hotel";
import AddEditHotel from "./SideTabPages/Hotel/Add";
import ManageHotelDetail from "./SideTabPages/Hotel/Detail";
import PinList from "./SideTabPages/ManagePin";
import AddPin from "./SideTabPages/ManagePin/Add";
import PinDetail from "./SideTabPages/ManagePin/Detail";
import ManageRoomList from "./SideTabPages/ManageRoom";
import AddRoom from "./SideTabPages/ManageRoom/Add";
import RoomDetail from "./SideTabPages/ManageRoom/Detail";
import RoomType from "./SideTabPages/RoomType";
import AddRoomType from "./SideTabPages/RoomType/Add";
import RoomTypeDetail from "./SideTabPages/RoomType/Detail";
import AddRoomPrice from "./SideTabPages/ManageRoom/AddPricing";
import Register from "./AuthPages/Register";

import CancelOrder from "./SideTabPages/ManageBooking/Cancelbooking";
import CancelOrderDetail from "./SideTabPages/ManageBooking/Cancelbooking/Detail";
import TransactionDetail from "./SideTabPages/ManageEearning/detail";
import BookingUpcomming from "./SideTabPages/ManageBooking/UpComingBooking";
import UpcomingOrderDetail from "./SideTabPages/ManageBooking/UpComingBooking/Detail";
import SendNotification from "./SideTabPages/Notification/Add";
import Notification from "./SideTabPages/Notification";
import ReviewManagement from "./SideTabPages/Review";
import ReportManagement from "./SideTabPages/Report";
import PricingSection from "./SideTabPages/Pricing";
import AddPricing from "./SideTabPages/Pricing/Add";
import PricingDetail from "./SideTabPages/Pricing/Detail";
import BookingHistory from "./SideTabPages/ManageBooking/BookingHistory";
import BookingDetails from "./SideTabPages/ManageBooking/BookingHistory/Detail";
import EditBooking from "./SideTabPages/ManageBooking/UpComingBooking/edit";

export const routes = [
  { path: "/register", component: <Register /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/otp", component: <Otp /> },
  { path: "/reset-password", component: <ResetPassword /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/manage-user", component: <ManageUser /> },

  { path: "/manage-user/add", component: <AddEditUser /> },

  { path: "/manage-user/edit/:id", component: <AddEditUser /> },
  { path: "/manage-user/detail/:id", component: <UserDetail /> },

  { path: "/event-booking/edit-job/:id", component: <EditJobPost /> },
  { path: "/event-booking/view-job/:id", component: <ViewJobPost /> },
  { path: "/inquiry", component: <InquiryManagement /> },
  { path: "/amenities", component: <Amenity /> },
  { path: "/amenities/add", component: <AddAmenity /> },
  { path: "/amenities/edit/:id", component: <AddAmenity /> },
  { path: "/amenities/detail/:id", component: <AmenitiesDetail /> },
  { path: "/roomamenity", component: <RoomAmenity /> },
  { path: "/roomamenity/add", component: <AddRoomAmenity /> },
  { path: "/roomamenity/edit/:id", component: <AddRoomAmenity /> },
  { path: "/roomamenity/detail/:id", component: <RoomAmenityDetail /> },

  { path: "/hotel", component: <ManageHotel /> },
  { path: "/hotel/add", component: <AddEditHotel /> },
  { path: "/hotel/edit/:id", component: <AddEditHotel /> },
  { path: "/hotel/detail/:id", component: <ManageHotelDetail /> },

  { path: "/pin", component: <PinList /> },
  { path: "/pin/add", component: <AddPin /> },
  { path: "/pin/edit/:id", component: <AddPin /> },
  { path: "/pin/detail/:id", component: <PinDetail /> },

  { path: "/room", component: <ManageRoomList /> },
  { path: "/room/add", component: <AddRoom /> },
  { path: "/room/edit/:id", component: <AddRoom /> },
  { path: "/room/detail/:id", component: <RoomDetail /> },
  // room rate add
  { path: "/room/roomprice", component: <AddRoomPrice /> },

  { path: "/roomtype", component: <RoomType /> },
  { path: "/roomtype/add", component: <AddRoomType /> },
  { path: "/roomtype/edit/:id", component: <AddRoomType /> },
  { path: "/roomtype/detail/:id", component: <RoomTypeDetail /> },

  { path: "/pricing", component: <PricingSection /> },
  { path: "/pricing/add", component: <AddPricing /> },
  { path: "/pricing/edit/:id", component: <AddPricing /> },
  { path: "/pricing/detail/:id", component: <PricingDetail /> },

  {
    path: "/service-provider/register",
    component: <RegisterServiceProvider />,
  },  
  {
    path: "/service-provider/register/add",
    component: <AddNewServiceProvider />,
  },
  {
    path: "/service-provider/register/edit/:id",
    component: <AddNewServiceProvider />,
  },
  {
    path: "/service-provider/register/detail/:id",
    component: <ServiceProviderDetail />,
  },
  {
    path: "/accounting",
    component: <Accounting />,
  },
  {
    path: "/review",
    component: <ReviewManagement />,
  },
  {
    path: "/report",
    component: <ReportManagement />,
  },
  {
    path: "/service-provider/request/detail/:id",
    component: <ServiceProviderDetail />,
  },
  {
    path: "/service-provider/request",
    component: <ServiceProviderRequest />,
  },
  {
    path: "/manage-booking",
    component: <OrderManagement />,
  },
  {
    path: "/manage-booking/:id",
    component: <OrderDetail />,
  },
  {
    path: "/cancel-booking",
    component: <CancelOrder />,
  },
  {
    path: "/cancel-booking/:id",
    component: <CancelOrderDetail />,
  },

  {
    path: "/upcomming-booking",
    component: <BookingUpcomming />,
  },
  {
    path: "/upcomming-booking/:id",
    component: <UpcomingOrderDetail />,
  },
  {
    path: "/upcomming-booking/edit/:id",
    component: <EditBooking />,
  },
  {
    path: "/booking-history",
    component: <BookingHistory />,
  },
  {
    path: "/booking-history/:id",
    component: <BookingDetails />,
  },
  {
    path: "/manage-hotel-admin",
    component: <ManageHotelAdmin />,
  },
  {
    path: "/manage-hotel-admin/detail/:id",
    component: <ManageHotelAdminDetail />,
  },
  {
    path: "/manage-hotel-admin/add",
    component: <AddEditHotelAdmin />,
  },
  {
    path: "/manage-hotel-admin/edit/:id",
    component: <AddEditHotelAdmin />,
  },

  {
    path: "/send-notification",
    component: <SendNotification />,
  },
  {
    path: "/notification",
    component: <Notification />,
  },

  {
    path: "/manage-earning",
    component: <ManageEarning />,
  },
  {
    path: "/manage-earning/:id",
    component: <TransactionDetail />,
  },
  {
    path: "/earnings",
    component: <Earnings />,
  },
  {
    path: "/manage-referal",
    component: <ManageReferal />,
  },
  {
    path: "/payments",
    component: <PaymentsManagement />,
  },

  {
    path: "/promocode",
    component: <Promocode />,
  },
  {
    path: "/promocode/add",
    component: <AddPromoCode />,
  },
  {
    path: "/promocode/edit/:id",
    component: <AddPromoCode />,
  },
  {
    path: "/promocode/detail/:id",
    component: <PromoCodeDetail />,
  },

  // { path: "/manage-user/detail/:id", component: <UserDetail /> },

  {
    path: "/help",
    component: <Help />,
  },
  {
    path: "/help/detail/:id",
    component: <HelpDetail />,
  },
  {
    path: "/system-access",
    component: <SystemAccess />,
  },
  {
    path: "/system-access/add",
    component: <AddSubAdmin />,
  },
  {
    path: "/system-access/edit/:id",
    component: <AddSubAdmin />,
  },

  { path: "/subscription", component: <ManageSubscription /> },
  { path: "/subscription/add", component: <SubscriptionAdd /> },
  { path: "/subscription/edit/:id", component: <SubscriptionAdd /> },
  { path: "/subscription/view/:id", component: <ViewSubscription /> },

  {
    path: "/role",
    component: <Role />,
  },
  {
    path: "/role/add",
    component: <AddRole />,
  },
  {
    path: "/role/edit/:id",
    component: <AddRole />,
  },

  {
    path: "/settings",
    component: <Settings />,
  },
  {
    path: "/settings/edit-profile",
    component: <EditProfile />,
  },
  {
    path: "/settings/password",
    component: <ManagePassword />,
  },
  {
    path: "/faq",
    component: <Faq />,
  },
  {
    path: "/faq/add",
    component: <AddFaq />,
  },
  {
    path: "/faq/edit/:id",
    component: <AddFaq />,
  },
  {
    path: "/content-page",
    component: <ContentPage />,
  },
  {
    path: "/content-page/add",
    component: <AddContentPage />,
  },
  {
    path: "/content-page/edit/:id",
    component: <AddContentPage />,
  },
  {
    path: "/add-promotion",
    component: <AddPromotion />,
  },
  {
    path: "/promotion",
    component: <PromotionList />,
  },
  {
    path: "/edit-promotion/:id",
    component: <AddPromotion />,
  },
  {
    path: "/basic-settings",
    component: <BasicSettings />,
  },
];
